import { Box, IconButton, Typography } from '@mui/material';
import { CardFileDTO } from '@src/adapters/dto/card/CardFileDTO';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useState } from 'react';
import FileView from './FileView';
import { CardFileType } from '@src/constants/CardFileType';

interface Props {
  file: CardFileDTO;
}

function File({ file }: Props) {
  const [viewOpen, setViewOpen] = useState(false);

  return (
    <Box
      sx={(theme) => ({
        padding: `${theme.spacing(2.5)} 0 ${theme.spacing(2)} ${theme.spacing(
          2
        )}`,
        ...(file.type === CardFileType.PrimaryScan && {
          backgroundColor: 'rgba(70, 110, 229, 0.05)',
        }),
        borderBottom: '1px solid #E6E7E9',
        display: 'flex',
        alignItems: 'center',
      })}>
      <Typography variant="body1" sx={{ width: '80%' }}>
        {file.name}
      </Typography>
      <Box>
        <IconButton
          aria-label="logout"
          onClick={() => setViewOpen((prev) => !prev)}
          size="large">
          <VisibilityIcon />
        </IconButton>
      </Box>
      {viewOpen && (
        <FileView
          isOpen={viewOpen}
          url={file.fileURL}
          originalFileName={file.name}
          close={() => setViewOpen(false)}
        />
      )}
    </Box>
  );
}

export default File;
